const appDetails = {
    webLink: "",
    googlePlayLink: "",
    appStoreLink: "",
    landingPage: "iframe-bids",
    signUpButton: false
}

export default appDetails;